<div class="grid">
	<!-- <div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
		<p-tag icon="pi cm-alert" [value]="('BOARD_USER_EXPORT_WARNING' | translate)" severity="warning"></p-tag>
	</div> -->
	<div class="col-12">
		<p-accordion>
			<p-accordionTab #boardUsersList (selectedChange)="togglePanel($event)" [disabled]="configured !== 0"> <!-- class="transparent-accordion" -->
				<ng-template pTemplate="header">
					<div class="grid flex align-items-center w-full -mb-3">
						<div [class]="!onExtendedMobile() ? 'col-10' : 'col-12 flex justify-content-center'" class="py-0"><span
								class="font-semibold white-space-nowrap">{{ 'USERS_DEVICE' | translate }}</span></div>
						<div [class]="!onExtendedMobile() ? 'col-2 flex align-items-center justify-content-end' : 'col-12 flex align-items-center justify-content-center'"
							class="py-0 pr-0" *ngIf="isAccess()">
							<!-- <p-menu #addBoardUser [model]="items" [popup]="true" appendTo="body"></p-menu>
							<p-button pTooltip="{{ 'ADD_USERS_DEVICE' | translate }}" class=""
								[disabled]="taskRunning  || !online || isFullMemory()" tooltipPosition="bottom" icon="pi cm-plus"
								size="large" (click)="$event.stopPropagation(); addBoardUser.toggle($event)" [rounded]="false"
								[text]="true" severity="primary">
							</p-button> -->
							<p-button pTooltip="{{ 'SYNC_DATA' | translate }}" class="" [disabled]="taskRunning || !online"
								tooltipPosition="bottom" icon="pi cm-cloud-sync" size="large"
								(click)="$event.stopPropagation(); syncData()" [rounded]="false" [text]="true" severity="secondary">
							</p-button>
							<p-button pTooltip="{{ 'EXPORT_LIST' | translate }}" class="" [disabled]="taskRunning"
								tooltipPosition="bottom" icon="pi cm-cloud-arrow-up" size="large"
								(click)="$event.stopPropagation(); exportList()" [rounded]="false" [text]="true" severity="secondary">
							</p-button>
							<p-button pTooltip="{{ 'DELETE_ALL' | translate }}" class="" [disabled]="taskRunning || !online"
								tooltipPosition="bottom" icon="pi cm-trash" size="large"
								(click)="$event.stopPropagation(); deleteBoardUsers()" [rounded]="false" [text]="true"
								severity="danger">
							</p-button>
						</div>
					</div>
				</ng-template>
				<div *ngIf="passwordSupport && !passwordVerify && online && (isTechnician || isImpersMode)">
					<div class="col-12 flex align-items-center justify-content-center bg-red-200 p-1 border-round-xl">
						<p-tag icon="pi cm-alert" [value]="('PASSWORD_REQUEST_OR_ERR_CON' | translate)" severity="danger"></p-tag>
					</div>
				</div>
				<div class="grid" *ngIf="!online">
					<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
						<p-tag icon="pi cm-alert" [value]="('OFFLINE_ALERT' | translate)" severity="warning"></p-tag>
					</div>
				</div>
				<div *ngIf="online && isAccess()">
					<app-board-users-table></app-board-users-table>
				</div>
			</p-accordionTab>
			<p-accordionTab #importUsersList>
				<ng-template pTemplate="header">
					<div class="grid flex align-items-center w-full pt-2 -mb-2">
						<div [class]="!onExtendedMobile() ? 'col-12' : 'col-12 flex justify-content-center'" class="py-0">
							<span class="font-semibold white-space-nowrap">{{'IMPORT_LIST_USERS' | translate }}</span>
						</div>
					</div>
				</ng-template>
				<div>
					<app-board-users-files-list></app-board-users-files-list>
				</div>
			</p-accordionTab>
		</p-accordion>
	</div>
</div>
<p-confirmDialog #confDialog class="p-confirm-dialog-content">
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>